import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'components';
import {
    Typography,
    Tabs,
    Tab,
    Box
} from '@mui/material';
import { ManageAddress } from './Manage_Address/ManageAddress';
import { ClientNameDropdown } from '../custom_component/clientNameDropdown';
import { userData } from 'services';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export function Settings() {
    const [value, setValue] = useState(0);
    const [userInfo, setUserInfo] = useState(null);
    const [selectedRowClientId, setSelectedRowClientId] = useState<number | ''>('');

    const jwt: any = localStorage.getItem('token');
    const labUserCheck: any = jwt ? JSON.parse(atob(jwt.split('.')[1])) : null;

    useEffect(() => {
        userData(0).then((res: any) => {
            const nextUserInfo = res?.data ?? null;
            setUserInfo(nextUserInfo);

            if (labUserCheck?.UserType !== 'Internal' && nextUserInfo?.userMap?.length > 0) {
                setSelectedRowClientId(nextUserInfo.userMap[0].clientID);
            }
        })
    }, [labUserCheck?.UserType])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    
    let nav: any = [{ name: 'Home', path: '/home' }, { name: 'Settings', path: '/home/settings' }];

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left' mb={2}>
                Settings
            </Typography>
            {(labUserCheck && labUserCheck?.UserType) && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mt: 2,
                        mb: 2
                    }}
                >
                    {userInfo && (
                        <Box>
                            <ClientNameDropdown
                                selectedClientId={selectedRowClientId}
                                setSelectedClientId={setSelectedRowClientId}
                                setPaginationModel={() => { }}
                                pageName="orderHistory"
                            />
                        </Box>
                    )}
                </Box>
            )}
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Manage Address" {...a11yProps(0)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <ManageAddress selectedClientId={selectedRowClientId} />
                </CustomTabPanel>
            </Box>
        </>
    );
}
